// LICENSE : MIT
"use strict";
/*
2.2.1.ひらがなと漢字の使い分け
JTFスタイルガイドは、ひらがなと漢字の使い分けについて、
『用字用語 新表記辞典第四版』(第一法規)および『日本語スタイルガイド』(テクニカルコミュニケーター協会編著)の 185 ページ「付録 1 漢字とひらがなの使い分け」を主たる参考文献とします。
特にマニュアルやウェブサイトなど、製品やサービスにともなって提供される文書を和訳する際には、
『日本語 スタイルガイド』(テクニカルコミュニケーター協会編著)の 185 ページ「付録 1 漢字とひらがなの使い分け」を参考にします。
実務翻訳では、業種や分野により異なる慣例に従って、ひらがなと漢字が使い分けられています。
同じ語句を 漢字とひらがなのどちらを使っても表記できる場合、特許、金融、法律の分野では漢字で書き、情報処理、ローカライズなどの分野ではひらがなで書く傾向があります。
実務翻訳において使用頻度が高い語句について、ひらがなと漢字の使用例を以下に示します。
この表を参考にして、できるだけ表記を統一するようにしてください。

用例集や用語集を作って表記の統一を図るのも有効な方法です。
漢字を使用する傾向の強い特許、金融、法律の分野では、以下のひらがなを使用する語句について、漢字を使用する場合があります。
 */
import prh from "textlint-rule-prh";
import path from "path";
export default function (context) {
    return prh(context, {
        rulePaths: [path.join(__dirname, "..", "dict", "2.2.1.yml")]
    });
}